import { useDispatch } from 'react-redux'
import { DRAWER_KEY, SUPPORT_STATUS_CTA_LABEL } from 'app-constants'
import { setDrawer } from 'slices/drawer'
import { AICard } from 'components'
import { STATICS } from 'statics'
import './style.scss'

export function HasMassive({ data }) {
  const { detailedMessage } = data
  const dispatch = useDispatch()

  function handleCtaClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderIcon() {
    return (
      <div className='icon'>
        <STATICS.INFO_TRIANGLE_FILLED />
      </div>
    )
  }

  return (
    <div className='has-massive'>
      <AICard
        title='Falha na sua região'
        message={detailedMessage}
        onCtaClick={handleCtaClick}
        icon={renderIcon()}
        ctaLabel={SUPPORT_STATUS_CTA_LABEL.CLOSE_DRAWER}
      />
    </div>
  )
}
